(function () {
  function getOptionValue(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function findVariant(variants, colorPos, colorValue, sizePos, sizeValue) {
    return variants.find((variant) => {
      if (colorPos && colorValue && getOptionValue(variant, colorPos) !== colorValue) {
        return false;
      }
      if (sizePos && sizeValue && getOptionValue(variant, sizePos) !== sizeValue) {
        return false;
      }
      return true;
    });
  }

  function findAvailableVariant(variants, colorPos, colorValue, sizePos, sizeValue) {
    return variants.find((variant) => {
      if (!variant.available) return false;
      if (colorPos && colorValue && getOptionValue(variant, colorPos) !== colorValue) {
        return false;
      }
      if (sizePos && sizeValue && getOptionValue(variant, sizePos) !== sizeValue) {
        return false;
      }
      return true;
    });
  }

  function setPressedState(buttons, selectedButton) {
    buttons.forEach((button) => {
      const isSelected = button === selectedButton;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function initLookbookCards(root) {
    const cards = (root || document).querySelectorAll('.ga-lookbook__row[data-product-id]');

    cards.forEach((card) => {
      if (card.dataset.gaLookbookInit === 'true') return;

      const variantsData = card.querySelector('.ga-lookbook__variants-data');
      const variantInput = card.querySelector('input[name="id"]');
      if (!variantInput || !variantsData) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsData.textContent);
      } catch (error) {
        return;
      }

      card.dataset.gaLookbookInit = 'true';

      const colorPos = parseInt(card.dataset.colorOptionPosition || '0', 10);
      const sizePos = parseInt(card.dataset.sizeOptionPosition || '0', 10);
      const colorButtons = Array.from(card.querySelectorAll('.ga-lookbook__color[data-color-value]'));
      const sizeButtons = Array.from(card.querySelectorAll('.ga-lookbook__size[data-size-value]'));
      const thumbImage = card.querySelector('.ga-lookbook__thumb-image');
      const addButton = card.querySelector('.ga-lookbook__add');

      let selectedColor = card.dataset.selectedColor || colorButtons[0]?.dataset.colorValue || '';
      let selectedSize = card.dataset.selectedSize || sizeButtons[0]?.dataset.sizeValue || '';

      function isSizeInStock(sizeValue) {
        if (!sizePos || !sizeValue) return false;
        return variants.some(
          (variant) => variant.available && getOptionValue(variant, sizePos) === sizeValue
        );
      }

      function resolveVariant() {
        if (colorPos && sizePos && selectedColor && selectedSize) {
          const exactAvailable = findAvailableVariant(
            variants,
            colorPos,
            selectedColor,
            sizePos,
            selectedSize
          );
          if (exactAvailable) return exactAvailable;

          const exactMatch = findVariant(variants, colorPos, selectedColor, sizePos, selectedSize);
          if (exactMatch) return exactMatch;
        }

        if (sizePos && selectedSize) {
          const sizeAvailable = variants.find(
            (variant) => variant.available && getOptionValue(variant, sizePos) === selectedSize
          );
          if (sizeAvailable) return sizeAvailable;

          const sizeMatch = findVariant(variants, 0, '', sizePos, selectedSize);
          if (sizeMatch) return sizeMatch;
        }

        if (colorPos && selectedColor) {
          const colorAvailable = variants.find(
            (variant) => variant.available && getOptionValue(variant, colorPos) === selectedColor
          );
          if (colorAvailable) return colorAvailable;
        }

        return variants.find((variant) => variant.available) || variants[0] || null;
      }

      function syncSizeAvailability() {
        if (!sizeButtons.length) return;

        sizeButtons.forEach((button) => {
          const sizeValue = button.dataset.sizeValue;
          const inStock = isSizeInStock(sizeValue);
          button.disabled = false;
          button.classList.toggle('is-unavailable', !inStock);
        });
      }

      function applyVariant(variant, options = {}) {
        const preserveSizeSelection = options.preserveSizeSelection === true;

        if (!variant) return;

        variantInput.value = variant.id;

        if (addButton) {
          addButton.disabled = !variant.available;
        }

        if (thumbImage && variant.featured_image && variant.featured_image.src) {
          thumbImage.src = variant.featured_image.src;
          thumbImage.removeAttribute('srcset');
        }

        if (colorPos) {
          selectedColor = getOptionValue(variant, colorPos) || selectedColor;
          const colorButton = colorButtons.find((button) => button.dataset.colorValue === selectedColor);
          if (colorButton) setPressedState(colorButtons, colorButton);
        }

        if (sizePos && !preserveSizeSelection) {
          selectedSize = getOptionValue(variant, sizePos) || selectedSize;
          const sizeButton = sizeButtons.find((button) => button.dataset.sizeValue === selectedSize);
          if (sizeButton) setPressedState(sizeButtons, sizeButton);
        }
      }

      function updateSelection(options = {}) {
        syncSizeAvailability();
        applyVariant(resolveVariant(), options);
      }

      colorButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedColor = button.dataset.colorValue;
          setPressedState(colorButtons, button);

          if (
            sizePos &&
            selectedSize &&
            !findAvailableVariant(variants, colorPos, selectedColor, sizePos, selectedSize)
          ) {
            const nextSizeButton = sizeButtons.find((sizeButton) =>
              findAvailableVariant(
                variants,
                colorPos,
                selectedColor,
                sizePos,
                sizeButton.dataset.sizeValue
              )
            );
            if (nextSizeButton) {
              selectedSize = nextSizeButton.dataset.sizeValue;
              setPressedState(sizeButtons, nextSizeButton);
            }
          }

          updateSelection();
        });
      });

      sizeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedSize = button.dataset.sizeValue;
          setPressedState(sizeButtons, button);
          updateSelection({ preserveSizeSelection: true });
        });
      });

      updateSelection();
    });
  }

  function initLookbook(root) {
    initLookbookCards(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initLookbook());
  } else {
    initLookbook();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-ga-lookbook-scroll')) {
      initLookbook(event.target);
    }
  });
})();
